import { render } from "./loader_overlay.vue?vue&type=template&id=dd615f2a&scoped=true&lang=pug"
import script from "./loader_overlay.vue?vue&type=script&lang=js"
export * from "./loader_overlay.vue?vue&type=script&lang=js"

import "./loader_overlay.vue?vue&type=style&index=0&id=dd615f2a&lang=scss&scoped=true"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd615f2a"]])

export default __exports__